import React, { memo, ReactNode } from 'react';
import { useInView } from 'react-intersection-observer';

interface IScrollChecker {
  name: string;
  sectionOrder: string[];
  children: ReactNode;
}

const ScrollChecker: React.FC<IScrollChecker> = ({ name, sectionOrder, children }) => {
  const { ref } = useInView({
    threshold: 0,
    onChange: (inView, entry) => {
      const lastScroll = (window as any).last_scroll;

      // Update last scroll only if we have scrolled below.
      const currentSectionIndex = sectionOrder.findIndex((section) => section === name);
      const lastScrollIndex = sectionOrder.findIndex((section) => section === lastScroll);
      const isLaterSection = currentSectionIndex >= lastScrollIndex;

      if (inView && isLaterSection) {
        (window as any).last_scroll = name;
      }
    },
  });

  return (
    <div ref={ref}>
      {children}
    </div>
  );
};

export default memo(ScrollChecker);
